export enum AppButtonVariant {
  onPrimary = 'on_primary',
  onSecondary = 'on_secondary',
  onTertiary = 'on_tertiary',
  onQuaternary = 'on_quaternary',
  onQuinary = 'on_quinary',
  onSenary = 'on_senary',
  onText = 'on_text',
  devTool = 'dev-tool',
  onHelp = 'help',
  onCheckout = 'on_checkout',
  onPrimaryGreen = 'on_primary_green',
  onTertiaryGreen = 'on_tertiary_green',
}
